const state = {
  // 当前轮播
  homeCarousel: 'Search'
};

const mutations = {
  // 设置当前轮播
  setHomeCarousel: (state, payload) => {
    state.homeCarousel = payload;
  }
};

const actions = {};

export default {
  state,
  mutations,
  actions
};
